
/* injects from baggage-loader */
require('./style.styl');

import React from 'react'
import PropTypes from 'prop-types'
import isEmail from 'validator/lib/isEmail'
import {closeModal} from 'redux/modules/ui/modal/actions'
import {reduxForm, Field, SubmissionError} from 'redux-form'
import SlideContainer from 'components/SlideContainer'
import FormInput from 'components/FormInput'
import {addUser} from 'redux/modules/users/actions'
import {showToast} from 'redux/modules/ui/toaster/actions'
import customerImage from 'components/Icon/images/customer.svg'

export class UserAddView extends React.Component {
  static propTypes = {
    closeModal: PropTypes.func,
    handleSubmit: PropTypes.func,
    invalid: PropTypes.bool,
    submitting: PropTypes.bool,
    error: PropTypes.object
  }

  render() {
    const {closeModal} = this.props

    return (
      <SlideContainer
        key='addUser'
        className='user-add-view'
        title='Add user'
        icon={customerImage}
        onCloseModal={closeModal}
      >
        <div className='user-add-view_content'>
          {this.renderForm()}
        </div>
      </SlideContainer>
    )
  }

  renderForm() {
    const {
      handleSubmit,
      submitting,
      invalid,
      closeModal
    } = this.props

    return (
      <form className='user-add-view_form' onSubmit={handleSubmit}>
        <Field name='name' label='Name' disabled={submitting} component={FormInput} />
        <Field name='phone' label='Phone (optional)' disabled={submitting} component={FormInput} />
        <Field name='email' label='Email' disabled={submitting} component={FormInput} />
        <div className='user-add-view_form_buttons'>
          <button
            type='submit'
            className='user-add-view_form_submit'
            disabled={submitting || invalid}
          >
            Add user
          </button>
          <button type='button' className='user-add-view_form_cancel' onClick={closeModal}>Cancel</button>
        </div>
        {this.renderError()}
      </form>
    )
  }

  renderError() {
    const {error} = this.props
    if (!error) return null

    return <div className='user-add-view_error'>{error.message}</div>
  }
}

export default reduxForm({
  form: 'addUser',
  validate: ({name, email}) => {
    const errors = {}

    if (!name) {
      errors.name = 'Please provide your name'
    }

    if (!email) {
      errors.email = 'Please provide email address'
    } else if (!isEmail(email)) {
      errors.email = 'Incorrect email address'
    }

    return errors
  },
  onSubmit: (values, dispatch) => new Promise((resolve, reject) => {
    dispatch(addUser(values))
      .success(() => {
        dispatch(closeModal())
        dispatch(showToast(`An email with instructions was sent to ${values.email}`))
        resolve()
      })
      .fail(error => {
        reject(new SubmissionError({_error: error}))
      })
  })
})(UserAddView)



// WEBPACK FOOTER //
// ./client/modals/UserAddView/index.js